import deepCopyObject from "../deepCopyObject";
import defaultPlanSelection from "./defaultPlanSelection";

/**
 *
 * @param {Object} routerQueryObj - next router.query object
 * @returns Plan filter selection in the form:  house_type: [], bedrooms: [], bathrooms: [], minimum_plot_size: []
 */
export default function getPlanFilterFromUrl(routerQueryObj) {
    // console.log("getPlanFilterFromUrl");
    const newSelected = deepCopyObject(defaultPlanSelection);
    Object.entries(routerQueryObj).map((arr) => {
        if (Array.isArray(arr[1])) {
            newSelected[arr[0]] = arr[1];
        } else {
            newSelected[arr[0]] = [arr[1]];
        }
    });
    return newSelected;
}
